export default "__VITE_ASSET__BhAKIaEb__"